import { StyleSheet, Dimensions } from "react-native";

const { width: viewportWidth } = Dimensions.get("window");

function wp(percentage: number) {
  const value = (percentage * viewportWidth) / 100;
  return Math.round(value);
}

const styles = StyleSheet.create({
  flagButtonView: {
    width: wp(20),
    height: "100%",
    minWidth: 32,
    justifyContent: "center",
    flexDirection: "row",
    alignItems: "center",
  },
  dropDownImage: {
    height: 14,
    width: 12,
  },
  numberText: {
    fontSize: 16,
    color: "#000000",
    flex: 1,
  },
});

export default styles;
